/**
 * Modèles de chantier livrés avec l'application.
 *
 * Une entreprise qui vient de s'inscrire n'a rien à charger : la fonction lui
 * paraît vide et inutile. Ces trois exemples par secteur la rendent
 * immédiatement utilisable — on les charge, on ajuste les quantités, et on
 * comprend l'intérêt d'en créer les siens.
 *
 * Les quantités et les prix sont des ordres de grandeur, à ajuster : ils ne
 * valent pas tarif. Le drapeau `_def` les distingue des modèles de
 * l'entreprise, qui seuls peuvent être modifiés ou supprimés.
 */

/** Chantiers types du bâtiment. */
export const MODELES_BATIMENT = [
  {
    nom: 'Salle de bain complète',
    _def: true,
    lignes: [
      { d: 'Démolition sanitaire', u: 'forfait', q: 1, p: 850, rem: 0 },
      { d: 'Chape ciment', u: 'm²', q: 6, p: 45, rem: 0 },
      { d: 'Étanchéité sous carrelage', u: 'm²', q: 6, p: 38, rem: 0 },
      { d: 'Carrelage 30×60', u: 'm²', q: 6, p: 38, rem: 0 },
      { d: 'Faïence murale', u: 'm²', q: 18, p: 42, rem: 0 },
      { d: 'Pose sanitaires', u: 'forfait', q: 1, p: 1200, rem: 0 },
    ],
  },
  {
    nom: 'Rénovation façade',
    _def: true,
    lignes: [
      { d: 'Échafaudage', u: 'm²', q: 120, p: 28, rem: 0 },
      { d: 'Nettoyage façade', u: 'm²', q: 120, p: 12, rem: 0 },
      { d: 'Enduit de façade', u: 'm²', q: 120, p: 55, rem: 0 },
      { d: 'Peinture 2 couches', u: 'm²', q: 120, p: 28, rem: 0 },
    ],
  },
  {
    nom: 'Peinture appartement',
    _def: true,
    lignes: [
      { d: 'Préparation murs', u: 'm²', q: 180, p: 15, rem: 0 },
      { d: 'Peinture 2 couches', u: 'm²', q: 180, p: 28, rem: 0 },
      { d: 'Peinture plafonds', u: 'm²', q: 75, p: 22, rem: 0 },
    ],
  },
];

/** Assortiments types du magasin. */
export const MODELES_MAGASIN = [
  {
    nom: 'Pack carrelage (20 m²)',
    _def: true,
    lignes: [
      { d: 'Carrelage 30×60', u: 'm²', q: 20, p: 38, rem: 0 },
      { d: 'Colle à carrelage (sac 25 kg)', u: 'sac', q: 5, p: 28, rem: 0 },
      { d: 'Mortier de joint (5 kg)', u: 'pce', q: 2, p: 22, rem: 0 },
      { d: 'Croisillons 2 mm (boîte)', u: 'pce', q: 1, p: 9, rem: 0 },
    ],
  },
  {
    nom: 'Pack peinture (appartement)',
    _def: true,
    lignes: [
      { d: 'Peinture blanche mate (15 L)', u: 'pce', q: 2, p: 89, rem: 0 },
      { d: 'Sous-couche (10 L)', u: 'pce', q: 1, p: 55, rem: 0 },
      { d: 'Rouleau + manchon', u: 'pce', q: 3, p: 12, rem: 0 },
      { d: 'Ruban de masquage', u: 'pce', q: 4, p: 6, rem: 0 },
    ],
  },
];

/**
 * Modèles proposés à une société : les exemples de son secteur, puis les
 * siens.
 *
 * Les exemples viennent en tête parce qu'ils sont là pour amorcer ; une
 * entreprise qui a créé les siens les reconnaît de toute façon à leur nom.
 *
 * @param {string} secteur secteur de la société
 * @param {Array} propres modèles créés par l'entreprise
 * @returns {Array} les modèles proposés
 */
export function modelesProposes(secteur, propres) {
  const exemples = secteur === 'magasin' ? MODELES_MAGASIN : MODELES_BATIMENT;
  return [...exemples, ...(propres || [])];
}
